import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const assetInwardList = createAsyncThunk('assetInward/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `asset_inward`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'zone_id': data?.zone_id,
                'level_id': data?.level_id,
                'asset_id': data?.asset_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const assetInwardDetails = createAsyncThunk('assetInward/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `asset_inward/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addAssetInward = createAsyncThunk('assetInward/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'asset_inward',
            data: {
                "premise_id": data?.values?.premise_id,
                "zone_id": data?.values?.zone_id,
                "level_id": data?.values?.level_id,
                "asset_id": data?.values?.asset_id,
                "inward_name": data?.values?.name,
                "asset_model": data?.values?.model_number,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateAssetInward = createAsyncThunk('assetInward/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'asset_inward',
            data: {
                "asset_inward_id": data?.values?.id,
                "premise_id": data?.values?.premise_id,
                "zone_id": data?.values?.zone_id,
                "level_id": data?.values?.level_id,
                "asset_id": data?.values?.asset_id,
                "inward_name": data?.values?.name,
                "asset_model": data?.values?.model_number,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delAssetInward = createAsyncThunk('assetInward/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `asset_inward/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetInward = createSlice({
    name: 'assetInward',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(assetInwardList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(assetInwardList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(assetInwardList.rejected, (state, action) => {
            state.loading = false;
        })

        builder.addCase(assetInwardDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    }
})

export default assetInward.reducer;